import { DISABLED_BUTTON_SUBMIT } from "App/constants"
import {
  DatatablesFooter,
  DatatablesFooterServerSide,
  IconButtonDatatable,
  InputOptionMaster,
  InputReactDatepicker,
  InputTextMaster,
  Loading,
  MasterButton,
  Modal,
  SearchInput,
  TabPanel,
  TableHeader,
  useTabStyle,
} from "App/Component/ui"
import {
  Grid,
  TableRow,
  Table,
  TableContainer,
  TableBody,
  Paper,
  AppBar,
  Tabs,
  Tab,
} from "@material-ui/core"
import React, { Suspense, useState } from "react"
import { useDatatables, useDatatablesServerSide } from "App/hooks"
import { TableCell } from "@material-ui/core"
import { stableSort, getComparator } from "App/Component/ui/datatable/utils"
import { PencilIcon, SelectIcon, TrashIcon } from "App/Assets"
import { defaultButtonSearch } from "./../Modal/ModalKunjunganBaru"
import {
  defaultDateDisplay,
  defaultToastError,
  defaultToastSuccess,
  getDayDuration,
  isNull,
  today,
} from "App/utils/helpers"
import { getNoRencanaKontrol, getNoRencanaKontrolUtama } from "../helpers"
import { headCells, headCellsRujukInternal, RESET_STATE_SEP } from "./helpers"
import { TYPE_REGISTRASI_RAWAT_JALAN } from "utils/registrations"
import FormRencanaKontrol from "./FormRencanaKontrol"
import FormNoSPRI from "../../../KunjunganRawatInap/ui/TableListNoSpri/FormNoSPRI"
import { RESET_STATE_SPRI } from "../../../KunjunganRawatInap/ui/TableListNoSpri/helpers"
import { FreezeTable } from "components/organism"
import Title from "App/Component/ui/title/Title"
import ModalDeleteConfirm from "App/Component/ui/Modal/ModalDeleteConfirm/ModalDeleteConfirm"
import { deleteSuratKontrol } from "./api"

const TableListNoRencanaKontrol = ({
  setShowModal,
  formData,
  setFormData,
  rows,
  setRows,
  rowsUtama,
  setRowsUtama,
  type = TYPE_REGISTRASI_RAWAT_JALAN,
  isModal = true,
}) => {
  const [disabled, setDisabled] = useState(defaultButtonSearch)
  const [disabledUtama, setDisabledUtama] = useState(defaultButtonSearch)

  const [filterRencanaKontrol, setFilterRencanaKontrol] = useState({
    valid_from: today(),
    valid_to: today(),
    filter: "2",
  })

  const [filterRencanaKontrolUtama, setFilterRencanaKontrolUtama] = useState({
    tanggal: new Date(),
    nomor_kartu: formData.insurance_no,
    filter: "2",
  })

  const handleChange = (text) => (e) => {
    setFilterRencanaKontrol({
      ...filterRencanaKontrol,
      [text]: e.target.value,
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setDisabled(DISABLED_BUTTON_SUBMIT)
    if (
      !isNull(filterRencanaKontrol.valid_from) &&
      !isNull(filterRencanaKontrol.valid_to)
    ) {
      const durasi = Math.abs(
        getDayDuration(
          filterRencanaKontrol.valid_to,
          filterRencanaKontrol.valid_from,
          false,
        ),
      )

      if (durasi > 10) {
        defaultToastError("Maksimal pencarian adalah 10 hari")
      } else {
        await setNewData()
      }
      setDisabled(defaultButtonSearch)
    }
  }

  const handleSubmitUtama = async (e) => {
    e.preventDefault()
    setDisabledUtama(DISABLED_BUTTON_SUBMIT)
    if (!isNull(filterRencanaKontrolUtama.tanggal)) {
      await setNewDataUtama()
    } else {
      defaultToastError("Harap pilih Tanggal !")
    }
    setDisabledUtama(defaultButtonSearch)
  }

  const setNewData = async () => {
    const res = await getNoRencanaKontrol(
      filterRencanaKontrol.valid_from,
      filterRencanaKontrol.valid_to,
      filterRencanaKontrol.filter,
      type,
    )
    if (res.state) {
      setRows(res.data)
    } else {
      defaultToastError(res.message)
    }
  }

  const setNewDataUtama = async () => {
    const res = await getNoRencanaKontrolUtama(
      filterRencanaKontrolUtama.tanggal,
      filterRencanaKontrolUtama.filter,
      filterRencanaKontrolUtama.nomor_kartu,
      type,
    )
    if (res.state) {
      setRowsUtama(res.data)
    } else {
      defaultToastError(res.message)
    }
  }

  if (isModal) {
    return (
      <ModalListKontrol
        setFormData={setFormData}
        handleChange={handleChange}
        rows={rows}
        rowsUtama={rowsUtama}
        formData={formData}
        type={type}
        handleSubmit={handleSubmit}
        disabled={disabled}
        disabledUtama={disabledUtama}
        filterRencanaKontrol={filterRencanaKontrol}
        filterRencanaKontrolUtama={filterRencanaKontrolUtama}
        setFilterRencanaKontrolUtama={setFilterRencanaKontrolUtama}
        setShowModal={setShowModal}
        setNewData={setNewData}
        setNewDataUtama={setNewDataUtama}
        handleSubmitUtama={handleSubmitUtama}
      />
    )
  } else {
    return (
      <DisplayBottom
        setFormData={setFormData}
        handleChange={handleChange}
        rows={rows}
        formData={formData}
        setShowModal={setShowModal}
        type={type}
        handleSubmit={handleSubmit}
        disabled={disabled}
        filterRencanaKontrol={filterRencanaKontrol}
        setNewData={setNewData}
      />
    )
  }
}

const DefaultComponent = ({
  filterRencanaKontrol,
  handleChange,
  rows,
  disabled,
  formData,
  setFormData,
  setShowModal,
  type,
  handleSubmit,
  setNewData,
}) => {
  const [formSEP, setFormSEP] = useState(RESET_STATE_SEP)
  const [formSpri, setFormSpri] = useState(RESET_STATE_SPRI)

  const handleClickUpdateRawatJalan = (row) => {
    setFormSEP({
      nomor_surat_kontrol: row.noSuratKontrol,
      nomor_sep: row.noSepAsalKontrol,
      kode_dokter: row.kodeDokter,
      nama_dokter: row.namaDokter,
      kode_poliklinik: row.poliTujuan,
      nama_poliklinik: row.namaPoliTujuan,
      tgl_rencana_kontrol: row.tglRencanaKontrol,
    })

    document
      .getElementsByClassName("form-no-rencana-kontrol")[0]
      .scrollIntoView({ behavior: "smooth" })
    document
      .getElementById("summary-form-rencana-kontrol")
      .setAttribute("open", "true")
  }

  const handleClickUpdateRawatInap = (row) => {
    setFormSpri({
      nomor_spri: row.noSuratKontrol,
      nomor_kartu: row.noKartu,
      kode_dokter: row.kodeDokter,
      nama_dokter: row.namaDokter,
      kode_poliklinik: row.poliTujuan,
      nama_poliklinik: row.namaPoliTujuan,
      tgl_rencana_kontrol: row.tglRencanaKontrol,
    })

    document
      .getElementsByClassName("form-no-spri")[0]
      .scrollIntoView({ behavior: "smooth" })
    document.getElementById("summary-form-spri").setAttribute("open", "true")
  }

  const handleTutupModalDanSetNoKontrol = async (nokontrol) => {
    setShowModal(false)
    setFormData({
      ...formData,
      nokontrol,
    })

    await setNewData()
  }

  const handleTutupModalDanSetNoSpri = async (nokontrol) => {
    setFormData({
      ...formData,
      nokontrol,
    })
    setFormSpri({
      ...formSpri,
      nomor_spri: nokontrol,
    })

    await setNewData()
  }

  return (
    <>
      {type === TYPE_REGISTRASI_RAWAT_JALAN ? (
        <FormRencanaKontrol
          noBpjs={formData.insurance_no}
          formData={formSEP}
          setFormData={setFormSEP}
          handleTutupModalDanSetNoKontrol={handleTutupModalDanSetNoKontrol}
        />
      ) : (
        <FormNoSPRI
          noBpjs={formData.insurance_no}
          formData={formSpri}
          registrasiID={formData.id_registration}
          setFormData={setFormSpri}
          handleTutupModalDanSetNoSpri={handleTutupModalDanSetNoSpri}
        />
      )}

      <Paper
        style={{
          padding: "1rem",
          marginTop: "1rem",
        }}
      >
        <Grid container spacing={3}>
          <Grid item sm={4}>
            <InputTextMaster
              name="valid_from"
              label="TANGGAL MULAI"
              id="valid_from"
              type="date"
              autoFocus={true}
              value={filterRencanaKontrol.valid_from}
              onChange={handleChange("valid_from")}
            />
          </Grid>
          <Grid item sm={4}>
            <InputTextMaster
              name="valid_to"
              label="TANGGAL SELESAI"
              id="valid_to"
              type="date"
              autoFocus={true}
              value={filterRencanaKontrol.valid_to}
              onChange={handleChange("valid_to")}
            />
          </Grid>

          <Grid item sm={4}>
            <InputOptionMaster
              name="filter"
              label="FILTER"
              id="filter"
              withSearch={false}
              value={filterRencanaKontrol.filter}
              onChange={handleChange("filter")}
              data={[
                {
                  value: "2",
                  label: "Tanggal Kontrol",
                },
                {
                  value: "1",
                  label: "Tanggal Entri",
                },
              ]}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <MasterButton
            className={"mt-1"}
            type="button"
            onClick={(e) => handleSubmit(e)}
            color={disabled.color}
            name={disabled.label}
            size="md"
          />
        </Grid>

        <div className="mt-2">
          <TableListRencanaKontrol
            rows={rows}
            formData={formData}
            setFormData={setFormData}
            type={type}
            setShowModal={setShowModal}
            handleClickUpdate={
              type === TYPE_REGISTRASI_RAWAT_JALAN
                ? handleClickUpdateRawatJalan
                : handleClickUpdateRawatInap
            }
            setNewData={setNewData}
          />
        </div>
      </Paper>
    </>
  )
}

const DefaultComponentUtama = ({
  filterRencanaKontrolUtama,
  setFilterRencanaKontrolUtama,
  rowsUtama,
  disabledUtama,
  formData,
  setFormData,
  setShowModal,
  type,
  handleSubmitUtama,
  setNewDataUtama,
}) => {
  const [formSEP, setFormSEP] = useState(RESET_STATE_SEP)
  const [formSpri, setFormSpri] = useState(RESET_STATE_SPRI)

  const handleClickUpdateRawatJalan = (row) => {
    setFormSEP({
      nomor_surat_kontrol: row.noSuratKontrol,
      nomor_sep: row.noSepAsalKontrol,
      kode_dokter: row.kodeDokter,
      nama_dokter: row.namaDokter,
      kode_poliklinik: row.poliTujuan,
      nama_poliklinik: row.namaPoliTujuan,
      tgl_rencana_kontrol: row.tglRencanaKontrol,
    })

    document
      .getElementsByClassName("form-no-rencana-kontrol")[0]
      .scrollIntoView({ behavior: "smooth" })
    document
      .getElementById("summary-form-rencana-kontrol")
      .setAttribute("open", "true")
  }

  const handleClickUpdateRawatInap = (row) => {
    setFormSpri({
      nomor_spri: row.noSuratKontrol,
      nomor_kartu: row.noKartu,
      kode_dokter: row.kodeDokter,
      nama_dokter: row.namaDokter,
      kode_poliklinik: row.poliTujuan,
      nama_poliklinik: row.namaPoliTujuan,
      tgl_rencana_kontrol: row.tglRencanaKontrol,
    })

    document
      .getElementsByClassName("form-no-spri")[0]
      .scrollIntoView({ behavior: "smooth" })
    document.getElementById("summary-form-spri").setAttribute("open", "true")
  }

  const handleTutupModalDanSetNoKontrol = async (nokontrol) => {
    setShowModal(false)
    setFormData({
      ...formData,
      nokontrol,
    })

    await setNewDataUtama()
  }

  const handleTutupModalDanSetNoSpri = async (nokontrol) => {
    setFormData({
      ...formData,
      nokontrol,
    })
    setFormSpri({
      ...formSpri,
      nomor_spri: nokontrol,
    })

    await setNewDataUtama()
  }

  const handleChange = (text) => (e) => {
    setFilterRencanaKontrolUtama({
      ...filterRencanaKontrolUtama,
      [text]: e.target.value,
    })
  }

  return (
    <>
      {type === TYPE_REGISTRASI_RAWAT_JALAN ? (
        <FormRencanaKontrol
          noBpjs={formData.insurance_no}
          formData={formSEP}
          setFormData={setFormSEP}
          handleTutupModalDanSetNoKontrol={handleTutupModalDanSetNoKontrol}
        />
      ) : (
        <FormNoSPRI
          noBpjs={formData.insurance_no}
          formData={formSpri}
          registrasiID={formData.id_registration}
          setFormData={setFormSpri}
          handleTutupModalDanSetNoSpri={handleTutupModalDanSetNoSpri}
        />
      )}

      <Paper
        style={{
          padding: "1rem",
          marginTop: "1rem",
        }}
      >
        <Grid container spacing={3}>
          <Grid item sm={4}>
            <InputTextMaster
              id="no_kartu"
              name="no_kartu"
              label={"NO KARTU"}
              value={formData.insurance_no}
              disabled
              error={isNull(formData.insurance_no)}
              message="Harap Input NO ASURANSI/BPJS Pada Form Kunjungan !"
            />
          </Grid>
          <Grid item sm={4}>
            <InputReactDatepicker
              selected={filterRencanaKontrolUtama.tanggal}
              name="tanggal"
              label="TANGGAL"
              id="tanggal"
              handleChangeToday={(e) =>
                setFilterRencanaKontrolUtama({
                  ...filterRencanaKontrolUtama,
                  tanggal: e,
                })
              }
              onChange={(e) =>
                setFilterRencanaKontrolUtama({
                  ...filterRencanaKontrolUtama,
                  tanggal: e,
                })
              }
              dateFormat="MM/yyyy"
              showMonthYearPicker
            />
          </Grid>

          <Grid item sm={4}>
            <InputOptionMaster
              name="filter"
              label="FILTER"
              id="filter"
              withSearch={false}
              value={filterRencanaKontrolUtama.filter}
              onChange={handleChange("filter")}
              data={[
                {
                  value: "2",
                  label: "Tanggal Kontrol",
                },
                {
                  value: "1",
                  label: "Tanggal Entri",
                },
              ]}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <MasterButton
            className={"mt-1"}
            type="button"
            onClick={(e) => handleSubmitUtama(e)}
            color={disabledUtama.color}
            name={disabledUtama.label}
            size="md"
          />
        </Grid>

        <div className="mt-2">
          <TableListRencanaKontrol
            rows={rowsUtama}
            formData={formData}
            setFormData={setFormData}
            type={type}
            setShowModal={setShowModal}
            handleClickUpdate={
              type === TYPE_REGISTRASI_RAWAT_JALAN
                ? handleClickUpdateRawatJalan
                : handleClickUpdateRawatInap
            }
            setNewData={setNewDataUtama}
          />
        </div>
      </Paper>
    </>
  )
}

// const ComponentRujukInternal = ({
//   formData,
//   setFormData,
//   setShowModal,
//   type,
// }) => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [totalData, setTotalData] = useState(0);

//   const setNewData = async (pages = 1, limit = 10) => {
//     if (isNull(formData.norm)) {
//       defaultToastError("Harap Pilih Pasien Terlebih Dahulu !");
//       return false;
//     }
//     setLoading(true);
//     const res = await getNoRujukInternal(formData.norm, pages, limit);
//     if (res.state) {
//       setRows(res.data);
//       setTotalData(res.meta.count);
//       setLoading(false);
//     } else {
//       setRows([]);
//       setLoading(false);
//       defaultToastError(res.message);
//     }
//   };

//   useEffect(() => {
//     (async () => {
//       await setNewData();
//     })();
//   }, [formData.norm]); // eslint-disable-line react-hooks/exhaustive-deps

//   return (
//     <>
//       <Paper
//         style={{
//           padding: "1rem",
//           marginTop: "1rem",
//         }}
//       >
//         <div>
//           <TableListRujukInternal
//             rows={rows}
//             formData={formData}
//             fetchData={setNewData}
//             loading={loading}
//             totalData={totalData}
//             setFormData={setFormData}
//             type={type}
//             setShowModal={setShowModal}
//           />
//         </div>
//       </Paper>
//     </>
//   );
// };

const ModalListKontrol = ({
  setShowModal,
  filterRencanaKontrol,
  filterRencanaKontrolUtama,
  setFilterRencanaKontrolUtama,
  handleChange,
  rows,
  rowsUtama,
  disabled,
  disabledUtama,
  formData,
  setFormData,
  type,
  handleSubmit,
  handleSubmitUtama,
  setNewData,
  setNewDataUtama,
}) => {
  const classes = useTabStyle()
  const [value, setValue] = useState(0)
  // const { formData } = useContext(FormContext);
  const handleChangeTab = (event, newValue) => {
    setValue(newValue)
  }
  function a11yProps(index) {
    return {
      id: `tab-panel-${index}`,
      "aria-controls": `TabPanel-${index}`,
    }
  }

  return (
    <>
      <Modal title={`No Kontrol`} width="80%" show={setShowModal}>
        <Suspense fallback={<div> Loading Tab Master Component...</div>}>
          <div className={classes.root}>
            <div className={classes.rootTab}>
              <AppBar
                position="static"
                classes={{
                  root: classes.appbar,
                }}
              >
                <Tabs
                  value={value}
                  onChange={handleChangeTab}
                  variant="fullWidth"
                  aria-label="Tabs No Kontrol"
                  classes={{
                    root: classes.tabs,
                    flexContainer: classes.fixedTab,
                  }}
                >
                  <Tab
                    classes={{
                      selected: classes.selected,
                      fullWidth: classes.tab,
                    }}
                    label="NO KONTROL"
                    {...a11yProps(0)}
                  />
                  <Tab
                    classes={{
                      selected: classes.selected,
                      fullWidth: classes.tab,
                    }}
                    label="DAFTAR SEMUA NO KONTROL"
                    {...a11yProps(1)}
                  />
                </Tabs>
              </AppBar>
              <TabPanel value={value} index={0}>
                <DefaultComponentUtama
                  setFormData={setFormData}
                  setFilterRencanaKontrolUtama={setFilterRencanaKontrolUtama}
                  rowsUtama={rowsUtama}
                  formData={formData}
                  setShowModal={setShowModal}
                  type={type}
                  handleSubmitUtama={handleSubmitUtama}
                  disabledUtama={disabledUtama}
                  filterRencanaKontrolUtama={filterRencanaKontrolUtama}
                  setNewDataUtama={setNewDataUtama}
                />
              </TabPanel>
              <TabPanel value={value} index={1}>
                <DefaultComponent
                  setFormData={setFormData}
                  handleChange={handleChange}
                  rows={rows}
                  formData={formData}
                  setShowModal={setShowModal}
                  type={type}
                  handleSubmit={handleSubmit}
                  disabled={disabled}
                  filterRencanaKontrol={filterRencanaKontrol}
                  setNewData={setNewData}
                />
                {/* <ComponentRujukInternal
                  setFormData={setFormData}
                  handleChange={handleChange}
                  rows={rows}
                  formData={formData}
                  setShowModal={setShowModal}
                  type={type}
                /> */}
              </TabPanel>
            </div>
          </div>
        </Suspense>
      </Modal>
    </>
  )
}

const DisplayBottom = ({
  filterRencanaKontrol,
  handleChange,
  rows,
  disabled,
  formData,
  setFormData,
  type,
  handleSubmit,
  setNewData,
}) => {
  return (
    <div
      style={{
        width: "100%",
        marginTop: "-0.5rem",
      }}
    >
      <DefaultComponent
        setFormData={setFormData}
        handleChange={handleChange}
        rows={rows}
        formData={formData}
        type={type}
        handleSubmit={handleSubmit}
        disabled={disabled}
        filterRencanaKontrol={filterRencanaKontrol}
        setNewData={setNewData}
      />
    </div>
  )
}

const TableListRencanaKontrol = ({
  rows,
  formData,
  setFormData,
  setShowModal,
  type,
  handleClickUpdate,
  setNewData,
}) => {
  const {
    page,
    setPage,
    setRowsPerPage,
    order,
    orderBy,
    length,
    handleRequestSort,
    rowsPerPage,
    setQ,
    data,
  } = useDatatables({
    rows: rows,
    orderByDefault: "nama",
    orderByRow: [
      "nama",
      "noSuratKontrol",
      "namaDokter",
      "namaPoliAsal",
      "noSepAsalKontrol",
      "noKartu",
    ],
  })

  const [showDeleteConfrim, setShowDeleteConfrirm] = React.useState(false)
  const [surkonSelected, setSurkonSelected] = React.useState(null)

  const handleClickSelect = (row) => {
    const defaultData = {
      nokontrol: row.noSuratKontrol,
      noKontrol: row.noSuratKontrol,

      tgl_rujukan: row.tglRencanaKontrol,
      kode_dpjp: row.kodeDokter,
      kode_dpjp_nama: row.namaDokter,
      kode_dpjp_dokter: row.namaDokter,
    }

    // noSepAsalKontrol;
    if (type === TYPE_REGISTRASI_RAWAT_JALAN) {
      setFormData({
        ...formData,
        ...defaultData,
        no_rujukan: row.noSuratKontrol,
      })

      if (type === TYPE_REGISTRASI_RAWAT_JALAN) {
        setShowModal(false)
      }
    } else {
      if (isNull(row.noSepAsalKontrol)) {
        setFormData({
          ...formData,
          ...defaultData,
        })
      } else {
        setFormData({
          ...formData,
          ...defaultData,
          no_rujukan: row.noSepAsalKontrol,
        })
      }
    }
  }

  const handleDelete = async () => {
    setShowDeleteConfrirm(true)
    const res = await deleteSuratKontrol(surkonSelected)

    if (res.state) {
      setPage(1)
      setNewData()
      setShowDeleteConfrirm(false)
      defaultToastSuccess(res.message)
    } else {
      setShowDeleteConfrirm(false)
      defaultToastError(res.message)
    }
    setSurkonSelected(null)
  }

  return (
    <>
      {showDeleteConfrim && (
        <>
          <ModalDeleteConfirm
            confirmHandle={handleDelete}
            setShowModalDeleteConfirm={setShowDeleteConfrirm}
          />
        </>
      )}

      <TableContainer
        className="custom-scrollbar"
        style={{
          maxHeight: "400px",
        }}
      >
        <div
          className=""
          style={{
            margin: "1rem 0",
          }}
        >
          <SearchInput withIcon={true} onchange={(e) => setQ(e.target.value)} />
        </div>
        <Table
          aria-labelledby="tableTitle"
          size={"medium"}
          aria-label="enhanced table"
        >
          <TableHeader
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            headCells={headCells}
          />

          <TableBody>
            {stableSort(data, getComparator(order, orderBy))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return (
                  <TableRow
                    hover
                    tabIndex={-1}
                    key={row.name}
                    style={{
                      backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                    }}
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      padding="none"
                      align="center"
                    >
                      {index + 1}
                    </TableCell>

                    <TableCell
                      component="th"
                      scope="row"
                      width="5%"
                      padding="none"
                      align="center"
                    >
                      <div
                        style={{
                          display: "flex",
                          gap: "0.3rem",
                        }}
                      >
                        {/* <TableAction
                          isDelete={false}
                          clickUpdate={() => handleClickUpdate(row)}
                        /> */}

                        <IconButtonDatatable
                          onClick={() => handleClickUpdate(row)}
                          style={{
                            background: "#F09F00",
                            borderRadius: "8px",
                            padding: "6px",
                          }}
                        >
                          <PencilIcon />
                        </IconButtonDatatable>

                        <IconButtonDatatable
                          aria-label="delete"
                          onClick={() => handleClickSelect(row)}
                          style={{
                            background: "#0FB054",
                            borderRadius: "8px",
                            padding: "6px",
                          }}
                        >
                          <SelectIcon
                            width={"12"}
                            height={"14"}
                            fill={"#fff"}
                          />
                        </IconButtonDatatable>
                        <IconButtonDatatable
                          aria-label="delete"
                          onClick={() => {
                            setSurkonSelected(row.noSuratKontrol)
                            setShowDeleteConfrirm(true)
                          }}
                          style={{
                            background: "#CC2B1D",
                            borderRadius: "8px",
                            padding: "6px",
                          }}
                        >
                          <TrashIcon
                            width={"12"}
                            height={"14"}
                            fill={"#fff"}
                          />
                        </IconButtonDatatable>
                      </div>
                    </TableCell>
                    <TableCell>{row?.noSuratKontrol}</TableCell>
                    <TableCell>{row?.tglRencanaKontrol}</TableCell>
                    <TableCell>{row?.jnsPelayanan}</TableCell>

                    <TableCell>{row?.nama}</TableCell>
                    <TableCell>{row?.namaDokter}</TableCell>
                    <TableCell>{row?.namaPoliAsal}</TableCell>
                    <TableCell>{row?.namaPoliTujuan}</TableCell>
                    <TableCell>{row?.noKartu}</TableCell>
                    <TableCell>{row?.noSepAsalKontrol}</TableCell>
                    <TableCell>{row?.tglSEP}</TableCell>
                    <TableCell>{row?.tglTerbitKontrol}</TableCell>
                  </TableRow>
                )
              })}
            {length === 0 && (
              <TableRow>
                <TableCell align="center" colSpan={headCells.length}>
                  Tidak ada data
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <DatatablesFooter
        page={page}
        length={length}
        rowsPerPage={rowsPerPage}
        selectRows={[10, 20]}
        onPageChange={(page) => setPage(page - 1)}
        onSelectChange={(e) => setRowsPerPage(e.target.value)}
      />
    </>
  )
}

const TableListRujukInternal = ({
  rows,
  totalData,
  loading,
  formData,
  setFormData,
  setShowModal,
  fetchData,
  type,
}) => {
  const handleClickSelect = (row) => {
    if (isNull(row?.no_rujuk_internal)) {
      defaultToastError("Nomor Rujuk Internal Tidak Ditemukan !")
      return false
    } else {
      const defaultData = {
        nokontrol: row.no_rujuk_internal,
      }

      // noSepAsalKontrol;
      if (type === TYPE_REGISTRASI_RAWAT_JALAN) {
        setFormData({
          ...formData,
          ...defaultData,
        })

        if (type === TYPE_REGISTRASI_RAWAT_JALAN) {
          setShowModal(false)
        }
      }
    }
  }

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: fetchData })

  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "",
    orderByRow: [],
  })

  return (
    <>
      <Title title="No Rujuk Internal" />
      <Loading show={loading} />
      <FreezeTable
        headCells={headCellsRujukInternal}
        handleRequestSort={handleRequestSort}
        order={order}
        length={length}
        orderBy={orderBy}
      >
        {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
          return (
            <TableRow hover tabIndex={-1} key={row.name}>
              <TableCell scope="row" padding="none" align="center">
                {index + 1}
              </TableCell>

              <TableCell scope="row" width="5%" padding="none" align="center">
                <div
                  style={{
                    display: "flex",
                    gap: "0.3rem",
                  }}
                >
                  <IconButtonDatatable
                    aria-label="delete"
                    onClick={() => handleClickSelect(row)}
                    style={{
                      background: "#0FB054",
                      borderRadius: "8px",
                      padding: "6px",
                    }}
                  >
                    <SelectIcon width={"12"} height={"14"} fill={"#fff"} />
                  </IconButtonDatatable>
                </div>
              </TableCell>
              <TableCell>
                {isNull(row?.no_rujuk_internal) ? "-" : row?.no_rujuk_internal}
              </TableCell>
              <TableCell>{row?.dokter_perujuk}</TableCell>
              <TableCell>
                {isNull(row?.dokter_penerima_rujuk)
                  ? "-"
                  : row?.dokter_penerima_rujuk}
              </TableCell>
              <TableCell>{row?.spesialis}</TableCell>
              <TableCell>{row?.konsul}</TableCell>
              <TableCell>{row?.keterangan}</TableCell>
              <TableCell>{row?.status_regis}</TableCell>
              <TableCell>
                {!isNull(row?.inserted_date)
                  ? defaultDateDisplay(row?.inserted_date)
                  : "-"}
              </TableCell>
              <TableCell>
                {!isNull(row?.updated_date)
                  ? defaultDateDisplay(row?.updated_date)
                  : "-"}
              </TableCell>
            </TableRow>
          )
        })}
        {rows.length === 0 && (
          <TableRow>
            <TableCell align="center" colSpan={headCellsRujukInternal.length}>
              Tidak ada data
            </TableCell>
          </TableRow>
        )}
      </FreezeTable>
      <DatatablesFooterServerSide
        totalData={totalData}
        pagination={pagination}
        handleChangeLimit={handleChangeLimit}
        onPrevious={onPrevious}
        onNext={onNext}
        currentPage={pagination.page}
        handleClickPageNumber={handleClickPageNumber}
      />
    </>
  )
}

export default TableListNoRencanaKontrol
